import { ref } from '@vue/composition-api'

export default (defaultValue = null) => {
  const valueRef = ref(defaultValue)
  const setter = (newValue) => {
    valueRef.value = newValue
  }
  return [valueRef, setter]
}
